import React from "react";
import SEO from "../commons/SEO";
import HeaderOne from "../commons/header/HeaderOne";

const Privacy = () => {
  return (
    <>
      <SEO title="Нүүр" />
      <main className="page-wrapper">
        <HeaderOne
          btnStyle="btn-small round btn-icon"
          HeaderSTyle="header-transparent"
        />

        {/* Start Slider Area  */}
        <div
          className="slider-area slider-style-1 variation-default height-850 bg_image"
          data-black-overlay="7"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/header.jpg)`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner text-center">
                  <h1 className="title display-one">Privacy policy</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p>Үйлчилгээний нөхцөл</p>
        <ol>
          <li>
            Ерөнхий нөхцөл
            <ol>
              <li>
                Sedu апп нь хэрэглэгчид Бэлгийн боловсрол олгох мэдээ мэдээлэл,
                зураг, контент, сургалт, зөвлөгөө өгөхтэй холбоотой үүсэх
                харилцааг зохицуулахад оршино.
              </li>
              <li>
                Энэхүү нөхцөл нь хэрэглэгч дээрх үйлчилгээг авахаас өмнө хүлээн
                зөвшөөрч баталгаажуулсны үндсэн дээр хэрэгжинэ.
              </li>
              <li>Хэрэглэгч 18 нас хүрсэн, эрх зүйн бүрэн чадамжтай байна.</li>
              <li>
                Sedu апп дээрх мэдээ мэдээлэл, зураг, контент, сургалт,
                зөвлөгөөг ашиг олох зорилгоор хуулбарлаж олшруулах, дуурайх, өөр
                бусад ямар ч зүйлд ашиглахыг хориглоно.
              </li>
            </ol>
          </li>
        </ol>
        <ol start="2">
          <li>
            Хэрэглэгчийн бүртгэл
            <ol>
              <li>
                Sedu апп-р үйлчлүүлэхдээ хэрэглэгч бүртгүүлсэн байна. Бүртгэлд
                нэвтрэх нэр, нэвтрэх нууц пин код үүсгэж илгээхийг заасан
                хүснэгтэд бөглөнө.
              </li>
              <li>Хэрэглэгчийн мэдээллийн нууцлалыг бид бүрэн хамгаална.</li>
              <li>
                Хэрэглэгчийн мэдээллийн үнэн зөв, бодит байдалд хэрэглэгч бүрэн
                хариуцлага хүлээнэ.
              </li>
              <li>
                Хэрэглэгч өөрийн үүсгэсэн нэвтрэх нэр болон нэвтрэх пин кодоо
                мартсан тохиолдолд бид хариуцлага хүлээхгүй.
              </li>
            </ol>
          </li>
          <li>
            Төлбөр тооцоо
            <ol>
              <li>Хэрэглэгчийн эрх нээлгэхэд сарын 20,000 төгрөг байна.</li>
              <li>Төлбөр буцаагдахгүй.</li>
              <li>Төлбөрийг QPay шилжүүлгээр хийнэ.</li>
            </ol>
          </li>
        </ol>
        <ol start="4">
          <li>
            Бусад
            <ol>
              <li>
                Садар самуун явдалтай тэмцэх тухай хуульд заасан хязгаарлалтын
                хүрээнд олгох мэдээ мэдээлэл, зураг, контент, зөвлөгөөг танд
                хүргэх болно.
              </li>
            </ol>
          </li>
        </ol>
        <p>&nbsp;</p>
        {/* End Slider Area  */}
      </main>
    </>
  );
};
export default Privacy;
